import {Disposable, Environment} from 'relay-runtime';
import {commitMutation, graphql} from 'react-relay';
import Util from '../../forecast-app/shared/util/util';
import {
	DeleteNovaAgentVersionInput,
	DeleteNovaAgentVersionMutation,
} from './__generated__/DeleteNovaAgentVersionMutation.graphql';
import {MutationInput, RelayOnCompleted, RelayOnError} from '../MutationTypes';

// The caller (NovaStudioPage.tsx) follows a successful delete with its own on-demand detail refetch to
// bring the version list forward, so the response only needs to identify the agent.
const mutation = graphql`
	mutation DeleteNovaAgentVersionMutation($input: DeleteNovaAgentVersionInput!) {
		deleteNovaAgentVersion(input: $input) {
			agent {
				id
			}
		}
	}
`;

function commit(
	environment: Environment,
	input: MutationInput<DeleteNovaAgentVersionInput>,
	onSuccess?: RelayOnCompleted<DeleteNovaAgentVersionMutation>,
	onError?: RelayOnError
): Disposable {
	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};

	return commitMutation<DeleteNovaAgentVersionMutation>(environment, {
		mutation,
		variables,
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
